module.exports = __webpack_public_path__ + "static/media/playspace_section3.12d2ca29.png";